import React, { Component } from 'react';
import { sendEmailCounts } from '../../../../api';
import Highcharts from 'highcharts/highstock';
import {config1} from "../data";
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

class StatsChart extends Component{
  constructor() {
    super();
    this.state = {
      block: true
    };
  }
  componentDidMount() {
    this.mounted = true;
    sendEmailCounts({}, {headers: {'tenantname': this.props.name}})
      .then(res=>{
        let data = res.data || {};
        let dateArr = [];
        function getDateArr(){
          function getDay (i){
            let now = new Date();
            let date = new Date(now.getTime() - i * 24 * 3600 * 1000);
            let curMonth = date.getMonth()+1;
            let curDay = date.getDate();
            curMonth = curMonth>9 ? curMonth : ("0"+curMonth);
            curDay = curDay>9 ? curDay : ("0"+curDay);
            return curMonth+"/"+curDay+"/"+date.getFullYear();
          }
          for(let i=0;i<15;i++){
            let day = getDay(i);
            dateArr.push(day);
          }
          dateArr.reverse();
        }
        if (this.mounted) {
          this.setState({block: false}, ()=>{
            getDateArr();

            let _dateSendEmail = data.emailUpdateDates.split(",");
            let _dataSendEmail = data.emailUpdateCounts.split(",");
            let _dateEmail = data.sendDates.split(",");
            let _dataEmail = data.sendCounts.split(",");

            let dataSendEmailTemp =[];
            let dataEmailTemp = [];
            let dataSendEmail = [];
            let dataEmail = [];
            for (let i=0;i<_dateSendEmail.length;i++){
              dataSendEmailTemp[i] = {
                date:_dateSendEmail[i],
                counts:_dataSendEmail[i]
              }
            }
            for (let i=0;i<_dateEmail.length;i++){
              dataEmailTemp[i] = {
                date:_dateEmail[i],
                counts:_dataEmail[i]
              }
            }
            for(let i=0;i<dateArr.length;i++){
              dataEmail[i] = 0;
              dataSendEmail[i] = 0;
              for(let n=0; n<dataSendEmailTemp.length;n++){
                let curdate = dataSendEmailTemp[n].date;
                if (dateArr[i] === curdate){
                  dataSendEmail[i] = parseInt(dataSendEmailTemp[n].counts);
                }
              }
              for(let j=0;j<dataEmailTemp.length;j++){
                let curdate = dataEmailTemp[j].date;
                if(dateArr[i] === curdate){
                  dataEmail[i] = parseInt(dataEmailTemp[j].counts);
                }
              }
            }

            config1.xAxis.categories = dateArr;
            config1.series[0].data = dataSendEmail;
            config1.series[1].data = dataEmail;

            // let _emailUpdateCounts = data.emailUpdateCounts.split(',').map(v=>v-0);
            // let _sendCounts = data.sendCounts.split(',').map(v=>v-0);
            // _emailUpdateCounts = new Array(Math.abs(15-_emailUpdateCounts.length)).fill(0).concat(_emailUpdateCounts);
            // _sendCounts = new Array(Math.abs(15-_sendCounts.length)).fill(0).concat(_sendCounts);
            //
            // config1.xAxis.categories = dateArr;
            // config1.series[0].data = _emailUpdateCounts;
            // config1.series[1].data = _sendCounts;
            Highcharts.chart('statsChart', config1);
          });
        }
      })
      .catch(err=>console.log(err));
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    let  { block } = this.state;
    return (
      <div className="tab-pane fade  in active" id="s1">
        <BlockUi tag="div"
                 loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
                 blocking={block}>
          <div id="statsChart"
               className="chart has-legend"
               style={{height: 400}} />
        </BlockUi>
      </div>
    );
  }
}

export default StatsChart;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/charts/statsChart.js